/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function WifiSlash(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M53.86491,34.61787A8.0029,8.0029,0,0,0,42.01886,45.38155l4.63294,5.093A185.51021,185.51021,0,0,0,15.31272,69.55151,15.73558,15.73558,0,0,0,9.097,80.48806a16.27045,16.27045,0,0,0,3.76351,12.27248L115.78283,213.99217a16.0416,16.0416,0,0,0,12.24131,5.6836,15.86724,15.86724,0,0,0,12.11428-5.61329l26.70577-31.4561,35.27175,38.77545a8.0029,8.0029,0,0,0,11.846-10.76369Z" />
        <Path d="M246.90336,80.50173a15.766,15.766,0,0,0-6.23425-10.95022,187.8405,187.8405,0,0,0-148.037-34.211A7.99849,7.99849,0,0,0,88.207,48.5798L181.6035,151.25965a8.00587,8.00587,0,0,0,5.923,2.61915c.04593,0,.09136,0,.13729-.001a8.007,8.007,0,0,0,5.967-2.82325l49.5227-58.33212A16.20333,16.20333,0,0,0,246.90336,80.50173Z" />
      </G>
    </Svg>
  );
}

export default WifiSlash;
